import domReady from "@wordpress/dom-ready";
import Swiper, { Navigation } from "swiper";
import "swiper/css";

let modalImagesSwiper = null;

domReady(() => {
	const modal = document.querySelector(".modal-wrapper.modal-wrapper-gallery");
	// console.log({ modal });
	if (modal) {
		// IMAGE
		const openImageModalItems = document.querySelectorAll(".open-image-modal");

		const modalImgsAttachmentsIds = [];
		openImageModalItems?.forEach((item) => {
			const thisAttachmentId = item.getAttribute("data-attachment-id");
			if (!modalImgsAttachmentsIds.includes(thisAttachmentId))
				modalImgsAttachmentsIds.push(thisAttachmentId);

			item.addEventListener("click", async () => {
				const thisSection = item.closest(
					"section.wp-block-zebra-blocks-gallery"
				);
				const index = modalImgsAttachmentsIds.indexOf(thisAttachmentId);

				document.body.classList.add("no-scroll");
				jQuery(modal).fadeIn(500, "easeInOutCirc", () => {
					modal.classList.add("show");
				});

				if (!thisSection.classList.contains("gallery-loaded")) {
					// console.log("GALLERY NOT LOADED");
					const allGallerySections = document.querySelectorAll(
						"section.wp-block-zebra-blocks-gallery"
					);
					allGallerySections?.forEach((section) =>
						section.classList.remove("video-loaded")
					);

					//NOW THE BUTTONS = IMAGES
					const imagesJson = await Promise.all(
						modalImgsAttachmentsIds.map((id) =>
							getJsonData(`/wp-json/wp/v2/media/${id}`)
						)
					);

					const imagesFullHtml = getHtmlForModalSlider(imagesJson);
					// console.log({ imagesFullHtml });
					const modalImagesSwiperWrapper =
						modal.querySelector(".swiper-wrapper");
					modalImagesSwiperWrapper.innerHTML =
						modalImagesSwiperWrapper.innerHTML + imagesFullHtml;
					modalImagesSwiper = initModalSwiper(modal, index);

					thisSection.classList.add("gallery-loaded");
				}

				modalImagesSwiper.slideTo(index);
			});
		});
	}
});

const getJsonData = async (url) => {
	const headers = {
		"Content-Type": "application/json",
		Accept: "application/json",
	};
	try {
		const apiResponse = await fetch(url, { headers });
		const json = await apiResponse.json();
		// console.log(json);
		return json;
	} catch (error) {
		console.log("Error:", error);
	} finally {
	}
};

const getFeaturedMedia = (media, size = "full") => {
	if (media.length === 0) return null;

	const mediaDetails = media.media_details;
	const mediaSize = mediaDetails.sizes[size];
	let mediaSrc = "";
	let mediaWidht = "";
	let mediaHeight = "";
	let srcset = "";
	let sizes = "";
	let limit = 1600;

	mediaSrc = mediaSize ? mediaSize.source_url : media.source_url;
	mediaWidht = mediaSize ? mediaSize.width : mediaDetails.width;
	mediaHeight = mediaSize ? mediaSize.height : mediaDetails.height;
	sizes = `(max-width: ${mediaWidht}px) 100vw, ${mediaWidht}px`;

	if (mediaWidht > limit) limit = mediaWidht;

	const newMediaSizes = Object.keys(mediaDetails.sizes).reduce(
		(object, key) => {
			if (key !== "thumbnail") {
				object[key] = mediaDetails.sizes[key];
			}
			return object;
		},
		{}
	);

	srcset =
		Object.values(newMediaSizes)
			.filter((item) => item.width <= limit)
			// Get the url and width of each size.
			.map((item) => [item.source_url, item.width])
			// Recude them to a string with the format required by `srcset`.
			.reduce(
				(final, current, index, array) =>
					final.concat(
						`${current.join(" ")}w${index !== array.length - 1 ? ", " : ""}`
					),
				""
			) || null;
	return `<img
        width="${mediaWidht}"
        height="${mediaHeight}"
        src="${mediaSrc}"
        class="attachment-${size} size-${size}"
        alt="${media.alt_text}"
        loading="lazy"
        srcSet="${srcset}"
        sizes="${sizes}"
        title="${media.title.rendered}"
      />`;
};

const getHtmlForModalSlider = (items) => {
	let returnHtml = "";
	items.forEach((item) => {
		const imageFull = getFeaturedMedia(item);
		returnHtml += '<div class="swiper-slide">';
		returnHtml += '<div class="slide-img">';
		returnHtml += "<figure>";
		returnHtml += imageFull;
		returnHtml += "</figure>";
		returnHtml += "</div>";
		returnHtml += "</div>";
	});

	return returnHtml;
};

const initModalSwiper = (modal, initialSlide = 0) => {
	const swiperElem = modal.querySelector(".swiper");
	const pageNext = modal.querySelector(".swiper-button-next");
	const pageLeft = modal.querySelector(".swiper-button-prev");

	return new Swiper(swiperElem, {
		initialSlide,
		modules: [Navigation],
		slidesPerView: 1,
		spaceBetween: 0,
		grabCursor: true,
		navigation: {
			nextEl: pageNext,
			prevEl: pageLeft,
		},
		keyboard: {
			enabled: true,
			onlyInViewport: false,
			pageUpDown: false,
		},
	});
};
